import module from 'guest/module.js'

module.service('GuestSoporte', GuestSoporteService)

function GuestSoporteService ($http, $filter, $schema) {
  const filterBy = $filter('filter')
  const orderBy = $filter('orderBy')

  this.get = (uid) => {
    return $http.post('/requisitions/select', {
        uid: uid,
      })
      .then((response) => new Requisitions(uid, response.data))
  }

  function Requisitions (uid, list) {
    this.__proto__.$uid = uid

    list.forEach((item) => (this.$push(item)))
  }

  Requisitions.prototype = {
    $uid: null,
    $length: 0,
    $push: function (data) {
      this[data.ID] = new Requisition(data)

      this.__proto__.$length++

      return this[data.ID]
    },
    $select: function (filter, order) {
      let list = Object.values(this)

      if (filter) list = filterBy(list, filter)
      if (order) list = orderBy(list, order)

      return list
    },
    $add: function (data) {
      return $http.post('/requisitions/insert', {
          uid: this.$uid,
          data: format(data, true),
        })
        .then((response) => this.$push(response.data))
    },
  }

  function Requisition (data) {
    Object.assign(this, format(data))
  }

  Requisition.prototype = {
    $response: function (response) {
      return $http.post('/requisitions/response', {
          uid: this.UID,
          id: this.ID,
          response: response,
        })
        .then((response) => (Object.assign(this, format(response.data))))
        .then(() => this)
    },
    $setStatus: function (status) {
      return $http.post('/requisitions/status', {
          uid: this.UID,
          id: this.ID,
          status: status,
        })
        .then((response) => (Object.assign(this, format(response.data))))
        .then(() => this)
    },
  }

  const format = (data, reverse) => {
    let object = $schema(data, {
      date: 'timestamp',
      modification_date: 'timestamp',
      responses: 'json',
    }, reverse)

    if (object.responses) {
      Object.values(object.responses)
        .forEach((response, i) => {
          object.responses[i] = $schema(response, {
            d: 'timestamp',
          }, reverse)
        })
    }

    return object
  }
}



// WEBPACK FOOTER //
// ./src/guest/services/Guest/Soporte.js